import { PriceControlPricesDTO } from '../dto';

export interface PriceControlPricesProps {
  purchasePriceBefore: number;
  purchasePriceAfter: number;
  costPriceAfter: number;
  salesPriceBefore: number;
  salesPriceAfter: number;
}

export class PriceControlPrices {
  purchasePriceBefore: number;
  purchasePriceAfter: number;
  costPriceAfter: number;
  salesPriceBefore: number;
  salesPriceAfter: number;

  constructor({
    purchasePriceBefore,
    purchasePriceAfter,
    costPriceAfter,
    salesPriceBefore,
    salesPriceAfter,
  }: PriceControlPrices) {
    this.purchasePriceBefore = purchasePriceBefore;
    this.purchasePriceAfter = purchasePriceAfter;
    this.costPriceAfter = costPriceAfter;
    this.salesPriceBefore = salesPriceBefore;
    this.salesPriceAfter = salesPriceAfter;
  }

  static fromDto = (dto: PriceControlPricesDTO): PriceControlPrices =>
    new PriceControlPrices({
      purchasePriceBefore: dto.purchasePriceBefore,
      purchasePriceAfter: dto.purchasePriceAfter,
      costPriceAfter: dto.costPriceAfter,
      salesPriceBefore: dto.salesPriceBefore,
      salesPriceAfter: dto.salesPriceAfter,
    });
}
